import { useStore } from "../../../../../store";
import { observer } from "mobx-react";
import env from "../../../../../config/env";

function AboutInstructor() {
  const { courseStore } = useStore();

  const instructor: any = courseStore?.classDetails?.tutors;

  return (
    <div className="flex flex-col gap-4 px-5 sm:px-8 py-5 bg-primary-purple-50 border-y border-primary-purple-100">
      <div className="flex flex-col gap-3">
        <p className="caption-text">Meet your Instructor</p>
        <div className="flex items-center gap-4">
          <img
            className="size-[60px] rounded-full"
            src={
              instructor?.image?.name
                ? `${env.IMAGE_API}${instructor?.image?.name}`
                : "/images/default-user.svg"
            }
            onError={(e) => {
              const target = e.currentTarget;
              target.onerror = null;
              target.src = "/images/default-user.svg";
            }}
          />
          <div>
            <h3 className="text-body-medium font-body-medium-bold sm:text-body-large sm:font-body-large">
              {instructor?.fullName}
            </h3>
            {instructor?.profession && instructor?.profession !== "Other" && (
              <span className="text-caption-text font-caption-text-bold sm:text-body-small sm:font-body-small-bold text-primary-purple-800">
                {instructor?.profession}
              </span>
            )}
          </div>
        </div>
        <div className="flex flex-wrap gap-1">
          {instructor?.linkedinUrl && (
            <a
              className="button-medium flex items-center justify-center gap-1.5 px-7 py-1.5 w-[calc(50%-2px)] sm:w-fit text-white bg-[#1A1A1A] rounded-full cursor-pointer"
              href={instructor?.linkedinUrl}
              target="_blank"
            >
              <img src="/images/icons/socialMedia/linkedin-white.svg" />
              LinkedIn
            </a>
          )}
          {instructor?.githubUrl && (
            <a
              className="button-medium flex items-center justify-center gap-1.5 px-7 py-1.5 w-[calc(50%-2px)] sm:w-fit text-white bg-[#1A1A1A] rounded-full cursor-pointer"
              href={instructor?.githubUrl}
              target="_blank"
            >
              <img src="/images/icons/socialMedia/linkedin-white.svg" />
              GitHub
            </a>
          )}
        </div>
      </div>

      <p className="body-small pl-4 border-l-[3px] h-fit border-primary-purple-500 text-primary-paradise-pink-800">
        {instructor?.bio || instructor?.description || ""}
      </p>

      <div className="flex gap-1 sm:gap-2.5">
        <div className="flex flex-col items-center gap-2 py-3.5 w-full rounded-2xl bg-white shadow-[0px_18px_24px_-8px_#00000012] sm:shadow-[0px_18px_26px_-4px_#00000005]">
          <img width={20} height={20} src="/images/icons/star-purple.svg" />
          <span className="text-body-medium font-body-medium-bold sm:text-body-large sm:font-body-large flex flex-col items-center gap-0.5">
            <span className="caption-text text-primary-purple-850">
              Reviews
            </span>
            {instructor?.ratingsCount}
          </span>
        </div>

        <div className="flex flex-col items-center gap-2 py-3.5 w-full rounded-2xl bg-white shadow-[0px_18px_24px_-8px_#00000012] sm:shadow-[0px_18px_26px_-4px_#00000005]">
          <img width={20} height={20} src="/images/icons/user-purple.svg" />
          <span className="text-body-medium font-body-medium-bold sm:text-body-large sm:font-body-large flex flex-col items-center gap-0.5">
            <span className="caption-text text-primary-purple-850">
              Students
            </span>
            {instructor?.studentsCount}
          </span>
        </div>
        <div className="flex flex-col items-center gap-2 py-3.5 w-full rounded-2xl bg-white shadow-[0px_18px_24px_-8px_#00000012] sm:shadow-[0px_18px_26px_-4px_#00000005]">
          <img width={20} height={20} src="/images/icons/course-purple.svg" />
          <span className="text-body-medium font-body-medium-bold sm:text-body-large sm:font-body-large flex flex-col items-center gap-0.5">
            <span className="caption-text text-primary-purple-850">
              Courses
            </span>
            {instructor?.coursesCount}
          </span>
        </div>
      </div>
    </div>
  );
}

export default observer(AboutInstructor);
